import { FC } from 'react';

import SectionMessage from '@atlaskit/section-message';
import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { Appearance } from '@atlaskit/section-message/dist/types/types';


interface MensagensErroServidorViewProps {
  aparencia: Appearance;
  titulo?: string;
  className?: string;
}

export const MensagensErroServidorView: FC<MensagensErroServidorViewProps> = ({aparencia, titulo, className, children}) => {
  return <Container role="alert" className={className}>
    <SectionMessage appearance={aparencia}>
      { titulo && 
        <header>
          <TextoDestacado as="span">{titulo}</TextoDestacado>
        </header>
      }
      {children}
    </SectionMessage>
  </Container>
}

const Container = styled.div`
  margin: ${Spacing.unit}px;
`;

const TextoDestacado = styled.span`
  font-size: 1.14286em;
  font-style: inherit;
  line-height: 1.25;
  color: ${({theme}) => theme.texto.enfase_alta};
  font-weight: 600;
  letter-spacing: -0.006em;
`;